import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const FieldsList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FieldItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
    width: 100%;
    padding: 16px 0;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};    

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }    

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 4px;
      flex-direction: column;      
      align-items: flex-start;
      justify-content: flex-start;
    }

  `};
`;

export const FieldLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.description};
    color: ${theme.v2.colors.neutral.lowDark};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }    
  `}
`;

export const FieldWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }

    span {
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      color: ${theme.v2.colors.neutral.lowPure};

      @media (max-width: ${theme.v2.breakpoints.md}) {
        font-size: ${theme.v2.font.sizes.xxs};
      }
    }      
  `}
`;

export const FieldValue = styled.span``;

export const PortLabelContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PortLabel = styled.span``;

export const PasswordWrapper = styled.div`
  display: flex;
  align-items: center;
`;
